var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { typeAlert, variantsAvatar, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import LocalStorageService from "../../services/localStorage";
import { useRolGetAll } from "../../fnx/rol/rolGetAll";
import { defaultDropDownPermissions, description, menuItem, optionSelect, optionsSelectClient, selectValueDefault, } from "./data";
import { RolView } from "./view";
import showToast from "../../services/toast";
import { useRolPost } from "../../fnx/rol/rolPost";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { showErrorToast } from "../../fnx/showError";
import { rolDisableClearData, rolPatchClearData, rolPostClearData, } from "../../store/rol/actions";
import { useRolPatch } from "../../fnx/rol/rolPatch";
import { ColumnsPermissions, rolDataForm } from "./rol.Dto";
import { useRolDisable } from "../../fnx/rol/rolDisable";
import { usePermissionGetAll } from "../../fnx/permission/permissionGetAll";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import { permissionClearData } from "../../store/permissions/actions";
import logoAffinity from "../../assets/images/logoAffinity.svg";
import { useCreateRol } from "./hooks/useCreateRol";
import { useRolManagement } from "./hooks/useRolManagement";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var RolAdmin = function () {
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _a = useState(false), trigger = _a[0], setTrigger = _a[1];
    var _b = useState(false), triggerPost = _b[0], setTriggerPost = _b[1];
    var _c = useState(false), triggerPatch = _c[0], setTriggerPatch = _c[1];
    var _d = useState(false), triggerDisable = _d[0], setTriggerDisable = _d[1];
    var _e = useState(false), triggerPermission = _e[0], setTriggerPermission = _e[1];
    var _f = useState([]), rolList = _f[0], setRolList = _f[1];
    var _g = useState(false), openModal = _g[0], setOpenModal = _g[1];
    var _h = useState(false), openModalDelete = _h[0], setOpenModalDelete = _h[1];
    var _j = useState(false), openModalDeletePermission = _j[0], setOpenModalDeletePermission = _j[1];
    var _k = useState(1), pageCatalog = _k[0], setPageCatalog = _k[1];
    var _l = useState(20), limitCatalog = _l[0], setLimitCatalog = _l[1];
    var _m = useState(0), countPagination = _m[0], setCountPagination = _m[1];
    var _o = useState(), valueName = _o[0], setValueName = _o[1];
    var _p = useState(), valueDescription = _p[0], setValueDescription = _p[1];
    var _q = useState([]), permissionList = _q[0], setPermissionList = _q[1];
    var _r = useState([]), dbPermissionList = _r[0], setDbPermissionList = _r[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _s = useState(false), isUpdate = _s[0], setIsUpdate = _s[1];
    var _t = useState(false), openDrawerPermission = _t[0], setOpenDrawerPermission = _t[1];
    var _u = useState(null), itemModal = _u[0], setItemModal = _u[1];
    var _v = useState(""), nameSearch = _v[0], setNameSearch = _v[1];
    var _w = useState(), bodyRequest = _w[0], setBodyRequest = _w[1];
    var _x = useState(rolDataForm), dataForm = _x[0], setDataForm = _x[1];
    var _y = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _y[0], setSeeToast = _y[1];
    var _z = React.useState(""), titleDelete = _z[0], setTitleDelete = _z[1];
    var _0 = React.useState(""), subTitleDelete = _0[0], setSubTitleDelete = _0[1];
    var _1 = React.useState(""), permissionId = _1[0], setPermissionId = _1[1];
    var _2 = useCreateRol(), openDrawer = _2.openDrawer, setOpenDrawer = _2.setOpenDrawer, useFormRol = _2.useFormRol;
    /*Llamada al getAll para recuperar todos los registros*/
    var _3 = useRolGetAll(trigger, clientId, pageCatalog, limitCatalog, valueName, valueDescription, nameSearch), responseRol = _3.responseRol, errorRol = _3.errorRol, loadingRol = _3.loadingRol;
    /*Llamada al getAll para recuperar todos los permisos*/
    var _4 = usePermissionGetAll(triggerPermission, clientId, pageCatalog, 10000), responsePermission = _4.responsePermission, errorPermission = _4.errorPermission, loadingPermission = _4.loadingPermission;
    /*Llamada al POST */
    var _5 = useRolPost(triggerPost, bodyRequest), responseRolPost = _5.responseRolPost, errorRolPost = _5.errorRolPost, loadingRolPost = _5.loadingRolPost;
    /*Llamada al Patch*/
    var _6 = useRolPatch(triggerPatch, bodyRequest), responseRolPatch = _6.responseRolPatch, errorRolPatch = _6.errorRolPatch, loadingRolPatch = _6.loadingRolPatch;
    // Rol Management hook
    var _7 = useRolManagement(setTrigger, setSeeToast), loadingSaveRolPermissions = _7.loadingSaveRolPermissions, openDrawerRolList = _7.openDrawerRolList, openDrawerEdit = _7.openDrawerEdit, selectedRol = _7.selectedRol, assignedPermissionsToEdit = _7.assignedPermissionsToEdit, handlePermissionAvailableToAssign = _7.handlePermissionAvailableToAssign, permissionAvailableToAssign = _7.permissionAvailableToAssign, handleOpenDrawerEdit = _7.handleOpenDrawerEdit, handleOpenDrawerRolList = _7.handleOpenDrawerRolList, setOpenDrawerEdit = _7.setOpenDrawerEdit, setOpenDrawerRolList = _7.setOpenDrawerRolList, onSearchAvailableToAssign = _7.onSearchAvailableToAssign, onSearchAssignedToEdit = _7.onSearchAssignedToEdit, permissionAvailableToAssignFiltered = _7.permissionAvailableToAssignFiltered, assignedPermissionsToEditFiltered = _7.assignedPermissionsToEditFiltered, availableQuery = _7.availableQuery, assignedQuery = _7.assignedQuery, onRoleMove = _7.onRoleMove, onRoleDelete = _7.onRoleDelete, onSaveRolPermissions = _7.onSaveRolPermissions;
    /*Llamada al Disable*/
    var _8 = useRolDisable(triggerDisable, itemModal), responseRolDisable = _8.responseRolDisable, errorRolDisable = _8.errorRolDisable, loadingRolDisable = _8.loadingRolDisable;
    var clickContextMenuPaymentMode = function (item) {
        var _a;
        setOpenModalDeletePermission(true);
        setTitleDelete("Permisos");
        setSubTitleDelete("el permiso ".concat((_a = item.description) === null || _a === void 0 ? void 0 : _a.toLowerCase()));
        setPermissionId(item.id ? item.id : "");
        setIsUpdate(true);
        // showEdit(item);
        /*Unifica listas quita duplicados y actualiza */
        var listPermissionDb = itemModal.permission.map(function (rol) { return rol.id; });
        //Quita el ID que deseo de la lista
        var updatedListPermissionDb = listPermissionDb.filter(function (id) { return id !== item.id; });
        //Actualiza la nueva lista de Permisos
        setBodyRequest({
            id: itemModal.id,
            clientId: itemModal.clientId,
            RolName: itemModal.code,
            RolDescription: itemModal.type,
            Permissions: updatedListPermissionDb,
        });
        setOpenDrawerPermission(false);
        setOpenModal(false);
    };
    var columnsPermissions = ColumnsPermissions(clickContextMenuPaymentMode);
    /*Call Trigger para GetAll*/
    var callRol = function () {
        setTrigger(!trigger);
    };
    var callPermission = function () {
        setTriggerPermission(!triggerPermission);
    };
    useEffect(function () {
        callRol();
    }, []);
    /*habilita trigger para getAll api de Permisos*/
    useEffect(function () {
        callPermission();
    }, [responseRol]);
    /*Valida respuesta del getAll y mapea objetos*/
    useEffect(function () {
        var _a, _b;
        if (responseRol && ((_a = responseRol === null || responseRol === void 0 ? void 0 : responseRol.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var listRols = (_b = responseRol === null || responseRol === void 0 ? void 0 : responseRol.data) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({
                id: item.id,
                type: item.description,
                code: item.name,
                description: "",
                clientId: item.clientId,
                fontSizeType: 12,
                fontSizeDescription: 12,
                codeLabel: "Nombre: ",
                typeLabel: "Descripción: ",
                permission: item.permissions,
            }); });
            setRolList(listRols);
            setTrigger(false);
        }
        else if (responseRol && (responseRol === null || responseRol === void 0 ? void 0 : responseRol.length) === 0) {
            setTrigger(false);
            setRolList([]);
        }
        if (responseRol === null || responseRol === void 0 ? void 0 : responseRol.pagingInfo) {
            setCountPagination(responseRol === null || responseRol === void 0 ? void 0 : responseRol.pagingInfo.totalItems);
        }
    }, [responseRol]);
    /*Valida respuesta del getAll de Permisos*/
    useEffect(function () {
        if (responsePermission && (responsePermission === null || responsePermission === void 0 ? void 0 : responsePermission.data.length) > 0) {
            setPermissionList(responsePermission);
            handlePermissionAvailableToAssign(responsePermission.data);
            setTriggerPermission(false);
            dispatch(permissionClearData());
        }
        else if (responsePermission && (responsePermission === null || responsePermission === void 0 ? void 0 : responsePermission.data.length) == 0) {
            setTriggerPermission(false);
            setPermissionList([]);
            dispatch(permissionClearData());
        }
    }, [responsePermission]);
    /*Valida respuesta de la creacion del ROL*/
    useEffect(function () {
        if (responseRolPost && (responseRolPost === null || responseRolPost === void 0 ? void 0 : responseRolPost.length) > 0) {
            showToastSuccessMessage("Rol creado con éxito.", typeAlert.success, setSeeToast);
            setTriggerPost(false);
            callRol();
            dispatch(rolPostClearData());
        }
        else if (errorRolPost) {
            showErrorToast(errorRolPost, setSeeToast, t);
            setTriggerPost(false);
        }
    }, [responseRolPost, errorRolPost]);
    /*Valida respuesta del update del ROL*/
    useEffect(function () {
        if (responseRolPatch && (responseRolPatch === null || responseRolPatch === void 0 ? void 0 : responseRolPatch.id.length) > 0) {
            showToastSuccessMessage("Rol actualizado con éxito.", typeAlert.success, setSeeToast);
            setTriggerPatch(false);
            callRol();
            dispatch(rolPatchClearData());
        }
        else if (errorRolPatch) {
            showErrorToast(errorRolPatch, setSeeToast, t);
            setTriggerPatch(false);
        }
    }, [responseRolPatch, errorRolPatch]);
    /*Valida respuesta del disable del ROL*/
    useEffect(function () {
        if (responseRolDisable && (responseRolDisable === null || responseRolDisable === void 0 ? void 0 : responseRolDisable.id.length) > 0) {
            showToastSuccessMessage("Rol desactivado con éxito.", typeAlert.success, setSeeToast);
            setTriggerDisable(false);
            callRol();
            dispatch(rolDisableClearData());
        }
        else if (errorRolDisable) {
            showErrorToast(errorRolDisable, setSeeToast, t);
            setTriggerDisable(false);
        }
    }, [responseRolDisable, errorRolDisable]);
    var onClickClearData = function (Data) {
        // Valida clean filtro y limpia los filtros
        if (Data.filter.type_filter === "empty") {
            setValueDescription(undefined);
            setValueName(undefined);
        }
        // Llama a la consulta general sin filtros
        callRol();
    };
    /*Mapea los filtros para enviarlos al API para busqueda*/
    var onClickApplyFilter = function (Data) {
        if (Data.filter.type_filter === "name") {
            setValueName(Data.filter.filter_value);
            setValueDescription(undefined);
        }
        else if (Data.filter.type_filter === "description") {
            setValueDescription(Data.filter.filter_value);
            setValueName(undefined);
        }
        callRol();
    };
    var handleSelectChange = function (event) {
        console.log("Event", event);
    };
    var searchFilter = function (term) {
        setNameSearch(term);
    };
    var filterStatus = function (item) {
        // const idSponsor = item?.sponsor.map((item: any) => item.id).join(",");
        // setTrigger(true);
    };
    var newItem = function () {
        setDataForm({
            id: "",
            clientId: "",
            RolName: "",
            RolDescription: "",
        });
    };
    var showEdit = function (row) {
        setDataForm({
            id: row.id,
            clientId: row.clientId,
            RolName: row.code,
            RolDescription: row.type,
        });
    };
    var onCloseSearch = function () {
        setNameSearch("");
        setTrigger(true);
    };
    var handleOnClickAdd = function () {
        newItem();
        setIsUpdate(false);
        setOpenDrawer(true);
    };
    /*Mapea el objeto para enviar en el POST*/
    var handleSubmitRol = function (dataRol) {
        if (isUpdate) {
            setBodyRequest({
                id: dataRol.id,
                clientId: dataRol.clientId,
                RolName: dataRol.RolName,
                RolDescription: dataRol.RolDescription,
            });
            setTriggerPatch(true);
            setOpenDrawer(false);
        }
        else {
            setBodyRequest({
                RolName: dataRol.RolName,
                RolDescription: dataRol.RolDescription,
            });
            setDataForm(rolDataForm);
            setOpenDrawer(false);
            setTriggerPost(true);
        }
        setOpenModal(false);
    };
    var handleOpenModal = function () {
        setOpenModal(true);
    };
    var onClickContextMenu = function (opt, item) {
        switch (opt.id) {
            case "1":
                setIsUpdate(true);
                setOpenDrawer(true);
                showEdit(item);
                break;
            case "2":
                setOpenModalDelete(true);
                setItemModal(item);
                break;
            case "3":
                // handleOpenDrawerEdit(item);
                handleOpenDrawerRolList(item);
                // const listPermissionDb: RolPermission[] = item.permission?.map(
                //   (item: RolPermission) => ({
                //     id: item.id,
                //     name: item.name,
                //     description: item.description,
                //   }),
                // );
                // setDbPermissionList(listPermissionDb);
                // setItemModal(item);
                // setIsUpdate(true);
                // showEdit(item);
                // setOpenDrawerPermission(true);
                break;
        }
    };
    var clickView = function (view) {
        setItemModal(view);
    };
    var onCloseDrawer = function () {
        setDataForm(rolDataForm);
        setOpenDrawer(false);
    };
    var onCloseDrawerPermissions = function () {
        setDbPermissionList([]);
        setOpenDrawerPermission(false);
    };
    var handleCloseModal = function () {
        setOpenModal(false);
    };
    var handleDelete = function () {
        setOpenModalDelete(false);
        setTriggerDisable(true);
    };
    var handleDeletePermission = function () {
        setOpenModalDeletePermission(false);
        setTriggerPatch(true);
        // setTriggerDisable(true);
    };
    var onHandleSaveRolPermission = function (data) {
        var listPermissionDb = itemModal.permission.map(function (item) { return item.id; });
        var listPermission = data.map(function (item) { return item.id; });
        var uniqueList = Array.from(new Set(__spreadArray(__spreadArray([], listPermissionDb, true), listPermission, true)));
        setBodyRequest({
            id: itemModal.id,
            clientId: itemModal.clientId,
            RolName: itemModal.code,
            RolDescription: itemModal.type,
            Permissions: uniqueList,
        });
        setTriggerPatch(true);
        setOpenDrawerPermission(false);
        setOpenModal(false);
    };
    var onChangePage = function (e) {
        setPageCatalog(e);
        setTrigger(true);
    };
    var onChangeRowsPerPage = function (e) {
        setLimitCatalog(e);
        setTrigger(true);
    };
    var drawerRolesListProps = {
        openDrawer: openDrawerRolList,
        view: 1,
        BgBackdrop: "transparent",
        BgcCloseButton: "#fff",
        colorIcon: "#000",
        bgColorDrawer: "#fff",
        customHeight: "40vh",
        img: logoAffinity,
        title: "Permisos",
        text: "",
        onValueApply: function () { },
        onClose: function () {
            setOpenDrawerRolList(false);
        },
        paginationProps: {
            count: 10,
            pagePagination: 1,
            rowsPerPages: 10,
            onChangePage: function () { },
            onChangeRowsPerPage: function () { },
            rowsPerPageOptions: [5, 10, 25],
        },
        onClickEdit: function () {
            if (selectedRol) {
                setOpenDrawerRolList(false);
                handleOpenDrawerEdit(selectedRol);
            }
        },
        data: assignedPermissionsToEdit,
        columns: [
            {
                field: "name",
                headerName: "Nombre",
            },
            {
                field: "description",
                headerName: "Descripcion",
            },
        ],
    };
    var drawerRolesEditProps = {
        open: openDrawerEdit,
        onClose: function () {
            setOpenDrawerEdit(false);
        },
        onRoleMove: onRoleMove,
        onRoleDelete: onRoleDelete,
        availableItems: permissionAvailableToAssign,
        assignedItems: assignedPermissionsToEdit,
        onSave: onSaveRolPermissions,
        title: "Asignar Permisos",
        subtitle: "Asigna los permisos que deseas asignar al usuario",
        availableTitle: "Permisos Disponibles",
        assignedTitle: "Permisos Asignados",
        availablePlaceholder: "Buscar",
        assignedPlaceholder: "Buscar",
        availableSearch: availableQuery,
        assignedSearch: assignedQuery,
        onAvailableSearchChange: onSearchAvailableToAssign,
        onAssignedSearchChange: onSearchAssignedToEdit,
        filteredAvailable: permissionAvailableToAssignFiltered,
        filteredAssigned: assignedPermissionsToEditFiltered,
        textCancelButton: "Cancelar",
        textSaveButton: "Asignar Permisos",
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingRol ||
                    loadingRolPost ||
                    loadingRolPatch ||
                    loadingRolDisable ||
                    loadingSaveRolPermissions, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Cargando roles..." }), _jsx(RolView, { title: "Rol", titleDrawer: isUpdate ? "Modificar Rol" : "Agregar Rol", list: rolList, avatarVariant: variantsAvatar.rounded, openModal: openModal, onSaveData: handleSubmitRol, loadingPostRol: loadingRolPost, dataForm: dataForm, modalTitle: itemModal === null || itemModal === void 0 ? void 0 : itemModal.title, editMode: isUpdate, clickView: clickView, onSubmit: handleDelete, viewLinearForm: true, onClose: handleCloseModal, onCloseSearch: onCloseSearch, 
                //createRol
                openDrawer: openDrawer, 
                // dataFormRol={useFormRol}
                setOpenDrawer: setOpenDrawer, openModalDelete: openModalDelete, setOpenModalDelete: setOpenModalDelete, openModalDeletePermission: openModalDeletePermission, setOpenModalDeletePermission: setOpenModalDeletePermission, onCloseDrawer: onCloseDrawer, searchFilter: searchFilter, filterStatus: filterStatus, handleOpenModal: handleOpenModal, onChangeSelect: handleSelectChange, onClickContextMenu: onClickContextMenu, onClickAdd: handleOnClickAdd, onClickCancel: handleCloseModal, onFilterApply: onClickApplyFilter, onFilterEmpty: onClickClearData, selectValueDefault: selectValueDefault, menuItem: menuItem, optionsSelect: optionSelect, optionsSelectClient: optionsSelectClient, inputHeigth: "20.3px", clientFilterLbl: "Cliente", 
                //Drawer Roles
                listDropDownPermissions: permissionList, columnsPermissions: columnsPermissions, rowsPermissions: dbPermissionList, buttonLblAddGrid: "Agregar Permisos", labelDropDownPermissions: "Permisos", txtSearchDropDownPermissions: "Buscar", defaultDropDownPermissions: defaultDropDownPermissions, titleDrawerPermission: "Agregar Permisos", textDescriptionPermission: description, openDrawerPermission: openDrawerPermission, titleDelete: titleDelete, subTitleDelete: subTitleDelete, onCloseDrawerPermission: onCloseDrawerPermissions, onClickSaveDataPermission: onHandleSaveRolPermission, modalTitlePermission: "Permisos", onSubmitDeletePermission: handleDeletePermission, countPagination: countPagination, onChangePage: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage, limitCatalog: limitCatalog, pageCatalog: pageCatalog, drawerRolesListProps: drawerRolesListProps, drawerDragAndDropProps: drawerRolesEditProps })] }));
};
